import getFetchOptions from './utils/getFetchOptions.js';
import fetchJSON from './utils/fetchJSON.js';
const options = {
  circuitBreaker: {
    id: 'walletConfig',
    timeout: 5000,
    resetTimeout: 300000,
    fallback: {}
  },
  headers: {
    'X-fwd-svc': 'atc'
  }
};
function walletConfigFetcher(environment) {
  return {
    path: environment === 'prod' ? 'https://awsacs-my-wallet-configuration.s3.amazonaws.com/default.json' : 'https://awsacsnp-my-wallet-configuration.s3.amazonaws.com/default.json',
    async fetch() {
      try {
        const data = await fetchJSON(this.path, getFetchOptions({
          ...options
        }));
        return data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching default wallet payment configurations: ', error);
      }
      return {};
    }
  };
}
export { walletConfigFetcher as default };
